import React from "react";
import styled from "styled-components";

// context
import { useSiteHeader } from "core/SiteHeader/context/useSiteHeader.js";

// context
import {
    PanelOverlayProvider,
    PanelOverlay,
    OpenButton,
} from "core/SiteHeader/Mobile/components/PanelOverlay/index.js";

// components
import Hamburger from "core/SiteHeader/components/Hamburger.js";
import Menu from "./Menu/index";
import Tools from "./Tools";

// data
import { primaryMenu } from "data/links";
const {
    name: productsTitle,
    links: { home, icons, photos, api, pricing },
} = primaryMenu.products;

const {
    name: tnpTitle,
    links: { about, blog, podcast, customerSupport },
} = primaryMenu.tnp;

// component
const PrimaryMenu = () => {
    const { setHamburgerModalIsOpen } = useSiteHeader();

    return (
        <PanelOverlayProvider
            position="left"
            id="mobile-primary-menu"
            label="Primary Menu"
            onOpen={() => setHamburgerModalIsOpen(true)}
            onClose={() => setHamburgerModalIsOpen(false)}
        >
            <OpenButton>
                <Hamburger />
            </OpenButton>
            <PanelOverlay>
                <Menu title={productsTitle} links={[home, icons, photos, api, pricing]} />
                <Tools />
                <Menu title={tnpTitle} links={[about, blog, podcast, customerSupport]} />
            </PanelOverlay>
        </PanelOverlayProvider>
    );
};

export default PrimaryMenu;
